<template>
    <owner-reservation-setup :setup_parameter="SETUP_PARAMETER_RESERVATION_NOTE_SETUP"></owner-reservation-setup>
</template>

<script>
import {SETUP_PARAMETER_RESERVATION_NOTE_SETUP} from "@/shared/constants";

export default {
    name: "Index",
    components: {
        "OwnerReservationSetup": () => import("@/components/owner/OwnerReservationSetup"),
    },
    data() {
        return {
            SETUP_PARAMETER_RESERVATION_NOTE_SETUP
        }
    },
}
</script>

<style scoped>

</style>
